import API from './API.js';
import axios from 'axios'

export default class Masters extends API {
    constructor() {
        super('masters');
    }
    async RequestNewMaster(data, headers = {}) {
        try {
            const response = await axios.post(`/newMaster/uploadMaster`, data, headers)
            return response.data
        } catch (error) {
            if (error.response) {
                // Request made and server responded
                return error.response.data;

            }
        }
    }
    //masters/update_teachers
    async updateTeachers(data, headers = {}) {
        try {
            const response = await axios.post(`/masters/update_teachers`, data, headers)
            return response.data
        } catch (error) {
            if (error.response) {
                // Request made and server responded
                return error.response.data;

            }
        }
    }
}
